<template>
  <div>
    <loading :loading="!pontosAtualizados" />
    <div v-for="ponto in pontosAtualizados" :key="ponto.id">
      <md-card>
        <md-card-media style="text-align: center">
          <br />
          <md-empty-state
            v-if="!ponto.fotos[0]"
            style="width: auto; height: 20vh"
            md-icon="videocam_off"
          />
          <img
            v-if="ponto.fotos[0]"
            style="width: auto; height: 20vh"
            :src="ponto.fotos[0]"
          />
        </md-card-media>

        <md-card-header>
          <div class="md-subheading">Enviado por: {{ ponto.usuarioNome }}</div>
          <div class="md-subheading">
            Criado em:
            {{
              new Date(ponto.horarioCriacao)
                .utcToLocalDate()
                .toLocaleDateString('pt-BR')
            }}
          </div>
        </md-card-header>

        <md-card-expand>
          <md-card-actions md-alignment="space-between">
            <div>
              <md-button
                class="md-raised md-primary"
                @click="() => abrirDialog(ponto.id)"
              >
                Marcar como lido
              </md-button>
              <md-button
                class="md-primary md-raised"
                @click.stop="() => openFotosTab(ponto.fotos)"
              >
                Ver Fotos
              </md-button>

              <md-button
                class="md-primary md-icon-button"
                @click.stop="() => flyTo(ponto)"
              >
                <md-icon>location_on</md-icon>
              </md-button>
            </div>

            <md-card-expand-trigger>
              <md-button class="md-icon-button">
                <md-icon>keyboard_arrow_down</md-icon>
              </md-button>
            </md-card-expand-trigger>
          </md-card-actions>

          <md-card-expand-content>
            <md-card-content>
              <li
                v-for="([chave, data], i) in objectToTuple(
                  ponto.dadosAssociados
                )"
                :key="i"
              >
                {{ compositeName(chave, ponto.tipo) }}: <b>{{ data }}</b>
              </li>
            </md-card-content>
          </md-card-expand-content>
        </md-card-expand>
      </md-card>
      <br />
    </div>
    <slider-right ref="slider">
      <ListagemFotosSig :fotos="fotosExibicao" />
    </slider-right>
    <md-dialog-confirm
      :md-active.sync="dialogMarcarComoLido"
      md-content="Confirme essa ação por favor"
      md-confirm-text="Marcar"
      md-cancel-text="Cancelar"
      @md-confirm="marcarComoLido"
    />
  </div>
</template>

<script>
import http from '../../utils/http'
import pontoSigTableNames from '../../utils/ponto-sig/table.names'
import Loading from '../Loading'
import SliderRight from '../SliderLeft'
import ListagemFotosSig from './ListagemFotosSig'

export default {
  name: 'ListagemPontosAtualizados',
  components: { Loading, ListagemFotosSig, SliderRight },
  props: {
    localId: String,
  },
  data() {
    return {
      dialogMarcarComoLido: false,
      dialogMarcarComoLidoId: null,
      fotosExibicao: [],
      pontosAtualizados: null,
    }
  },
  async beforeMount() {
    await this.listarPontosAtualizados()
  },
  mounted() {},
  methods: {
    async listarPontosAtualizados() {
      this.pontosAtualizado = null

      this.pontosAtualizados = (
        await http.get(`ponto-sig/local/${this.localId}/atualizados`)
      ).pontosAtualizados

      if (this.pontosAtualizados.length === 0) {
        return
      }

      this.objectToTuple(this.pontosAtualizados[0].dadosAssociados)
    },
    async marcarComoLido() {
      await http.put(`ponto-sig/${this.dialogMarcarComoLidoId}/marcar-lido`)

      await this.listarPontosAtualizados()

      this.$emit('change')
    },
    abrirDialog(id) {
      this.dialogMarcarComoLido = true
      this.dialogMarcarComoLidoId = id
    },
    objectToTuple(obj) {
      const mutavel = { ...obj }

      Object.keys(mutavel).forEach((key) => {
        const isOutro = key.substr(key.length - 5) === 'Outro'

        const chaveOriginal = key.substr(0, key.length - 5)

        if (mutavel[chaveOriginal] === 'Outro' && isOutro) {
          mutavel[chaveOriginal] = mutavel[key]
        }

        if (isOutro) {
          delete mutavel[key]
        }
      })

      return Object.keys(mutavel).map((e) => [e, mutavel[e]])
    },
    compositeName(chave, tipo) {
      const tipoString = pontoSigTableNames.tipoPorNumero[tipo]

      return pontoSigTableNames.columns[tipoString][chave]
    },
    async openFotosTab(fotos) {
      await this.$refs.slider.toogleTab()
      this.fotosExibicao = fotos
    },
    flyTo(ponto) {
      this.$emit('flyTo', ponto)
    },
  },
}
</script>

<style scoped></style>
